import moment from "moment";
// Importe pdv 
// Importe user
const definitions = [
    {
        code:'VALIDNOTIFICATION002', 
        title:"Nouvelle entrée", 
        body:"L'objet a bien été ajouté",
        state:'success'
    },
    {
        code:'ERRNOTIFICATION002', 
        title:"Nouvelle entrée", 
        body:"Une erreur est survenue lors de l'enregistrement.",
        state:'error'
    },
    {
        code:'VALIDNOTIFICATION001', 
        title:"Mise à jour", 
        body: "La mise à jour a bien été effectué",
        state:'success'
    },
    {
        code:'ERRNOTIFICATION001', 
        title:"Mise à jour", 
        body:"Une erreur est survenue lors de la mise à jour.",
        state:'error'
    },
    {
        code:'VALIDNOTIFICATION003', 
        title:"Suppression", 
        body: "La mise à jour a bien été effectué",
        state:'success'
    },
    {
        code:'ERRNOTIFICATION003', 
        title:"Suppression",
        body:"Une erreur est survenue lors de la suppression.",
        state:'error'
    },
    {
        code:'VALIDNOTIFICATION004', 
        title:"Remboursement", 
        body: "Le remboursement total du client a bien été effectué",
        state:'success'
    },
    {
        code:'ERRNOTIFICATION004', 
        title:"Remboursement",
        body:"Une erreur est survenue lors du remboursement total du client.",
        state:'error'
    },
    {
        code:'VALIDNOTIFICATION005', 
        title:"Remboursement partiel", 
        body: "Le remboursement partiel du client a bien été effectué",
        state:'success'
    },
    {
        code:'ERRNOTIFICATION005', 
        title:"Remboursement partiel",
        body:"Une erreur est survenue lors du remboursement partiel du client.",
        state:'error'
    }
];
function makeNotification(payload) {
    const obj = definitions.find(x=> x.code === payload.code)
    return {
        createdAt:  moment(),
        title: obj.title,
        body : obj.body,
        isRead : false,
        source : payload.extra,
        type: obj.state, 
        extraID: payload.id ? payload.id : 0,
        subscriptions: payload.pdv
    }
}

export { makeNotification };